export default {
	setFullPackageList(state, val){
		state.fullPackageList  = Array.from(val.list);
	},
}



// WEBPACK FOOTER //
// ./src/Package/store/mutations.js